import styled from "styled-components";

const StyledLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

const StyledNumber = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  ${({ paddingTop }) => paddingTop && "padding-top: 10px"};
`;

const StyledValue = styled.div`
  color: #45a09d;
  font-size: 22px;
  font-weight: 600;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 1080px;
  margin-bottom: 20px;
`;

const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: white;
  border-right: 1px solid #e5e7ec;
  flex: 1;

  &:first-child {
    border-radius: 10px 0 0 10px;
  }

  &:last-child {
    border-radius: 0 10px 10px 0;
    border: 0;
  }
`;

const StyledOrgContainer = styled.div`
  width: 1080px;
  display: flex;
  flex-direction: column;
`;

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
  padding: 20px;

  &:hover {
    background: #f9fafb;
    cursor: pointer;
  }
`;

const StyledTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
`;

const StyledName = styled.h3`
  font-size: 18px;
  color: #45a09d;
  margin: 0 10px 0 0;
`;

const StyledStatusPill = styled.div`
  background: #def7ec;
  color: #05553f;
  font-weight: 600;
  font-size: 10px;
  border-radius: 10px;
  padding: 3px 8px;
`;

const StyledBottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledStatistic = styled.div`
  color: #757b88;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 8px;

  svg {
    height: 18px;
    margin-right: 3px;
  }
`;

const StyledId = styled.div`
  opacity: 0.8;
  width: 300px;
`;

const StyledMore = styled.div`
  opacity: 0.5;
`;

export {
  StyledContainer,
  StyledItem,
  StyledLabel,
  StyledNumber,
  StyledValue,
  StyledOrgContainer,
  StyledRow,
  StyledTop,
  StyledName,
  StyledStatusPill,
  StyledBottom,
  StyledStatistic,
  StyledId,
  StyledMore
};
